import React, { Suspense } from 'react';
import { DDD } from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import DDDHelmet from "../components/UI/DDDHelmet";
import classes from "./AddCustomer.module.scss";
const ThemesCreator = React.lazy(() => import('../components/themes/ThemesCreator'));


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const ThemeMaker = () => {
    return(<>
        <DDDHelmet title="Theme Maker"/>
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
        <Suspense fallback={<div>Loading...</div>}>
            <ThemesCreator />
        </Suspense>
        </div>
    </>)
};
export default ThemeMaker;